export const getRandomImage = (): string => {
	return String(Math.floor(Math.random() * 29) + 1) + '.png'
}
